<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <div slot="header">Liquidación Final</div>
            <b-form-group
              label="Personal"
              label-for="personal"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarPersonal">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="personal"
                  :value="personalNombre"
                  :state="personalValido"
                  readonly
                  type="text"/>
              </b-input-group>
              <b-form-invalid-feedback id="personalFeedback">
                {{ personalInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Liquidación"
              label-for="fechaLiquidacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaLiquidacion" 
                v-model="fechaLiquidacion" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              v-if="!readOnly"
              label="Importe"
              label-for="liquidacionFinal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="liquidacionFinal"
                v-model.trim="$v.liquidacionFinal.$model" 
                :state="liquidacionFinalValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="liquidacionFinalFeedback">
                {{ liquidacionFinalInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="readOnly"
              label="Importe"
              label-for="liquidacionFinal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="liquidacionFinal"
                :value="liquidacionFinal | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="2"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="searchPersonalModal" 
        title="Seleccionar Personal"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="personal-search-modal">
      <app-search-personal
        @personalSeleccionado="personalSeleccionado">
      </app-search-personal>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchPersonal from '../personal/SearchList.vue'
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { decimal, minValue, maxLength } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'liquidacionSueldosFinal/getField',
  mutationType: 'liquidacionSueldosFinal/updateField',
});

export default {
  name: 'LiquidacionesSueldosLiquidacionFinal',
  components: {
    appSearchPersonal: SearchPersonal,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      personalValido: null,
      personalInvalidoMsj: '',
      liquidacionFinalValida: null,
      liquidacionFinalInvalidaMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'personal',
      'personalNombre',
      'fechaLiquidacion',
      'liquidacionFinal',
      'observaciones',
      'importeReadOnly'
    ]),
  },
  created() {
    let liquidacionFinalId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        liquidacionFinalId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('liquidacionSueldosFinal/inicializar', liquidacionFinalId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'liquidacionFinal' || validarTodos) {
        this.liquidacionFinalValida = null;
        this.liquidacionFinalInvalidaMsj = this.displayErrorMonto (this.$v.liquidacionFinal.$error, 
          this.$v.liquidacionFinal.decimal, this.$v.liquidacionFinal.minValue); 
        
        if (this.liquidacionFinalInvalidaMsj.trim() != '') {
          this.liquidacionFinalValida = false;
        }
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    displayErrorMonto( fieldError, fieldErrorDecimal, fieldErrorMinValue) {
      let errorMsj = '';
      if (fieldError) {
        if (fieldErrorDecimal) {
          errorMsj = 'El monto ingresado debe ser un valor numérico';
        } else if (fieldErrorMinValue) {
          errorMsj = 'El monto ingresado no es válido';
        }
      }
      return errorMsj;
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let personalError = true;
      if (this.personal) {
        if (this.personal.id) {
          if (this.personal.id != 0) {
            personalError = false;
          }
        }
      }
      if (personalError) {
        save = Boolean(false);
        this.personalValido = false;
        this.personalInvalidoMsj = "Debe seleccionar el personal correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('liquidacionSueldosFinal/save')
            .then( () => this.showModalMsj ('La liquidación final se registró con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: 'LiquidacionesSueldos' });
    },
    goBack() {
      this.$router.push({ name: 'LiquidacionesSueldos' });
    },
    seleccionarPersonal() {
      this.$refs.searchPersonalModal.show()
    },
    personalSeleccionado(item) {
      this.$refs.searchPersonalModal.hide();
      this.$store.dispatch('liquidacionSueldosFinal/setPersonal', item);
    },
  },
  validations: {
    liquidacionFinal: { 
      decimal, 
      minValue: minValue(0) 
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
</style>
